export default __webpack_public_path__ + "static/wistful-f25f018ad6f6d9831ed7cddbc97f66ef.svg";